import { motion } from "framer-motion";
import { INDUSTRIES } from "@/lib/data";
import { useSEO } from "@/hooks/useSEO";
import { MaskedLines } from "@/components/motion";

export default function Industries() {
  useSEO({
    title: "Industries — Oil & Gas · LNG · Power · Metals · Renewables | EnPrex Services",
    description: "EnPrex serves the world's most complex trading operations across Oil & Gas, LNG, Power, Utilities, Metals, Mining, Agriculture and Renewable Energy.",
    path: "/industries",
  });
  return (
    <div data-testid="industries-page">
      <section className="container-x pt-24 pb-16 border-b border-white/5">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <div className="text-[11px] font-bold uppercase tracking-[0.3em] text-[#D4AF37] mb-6 font-mono">— Industries</div>
          <h1 className="font-display text-5xl md:text-7xl font-light text-white tracking-tighter leading-[0.95] max-w-4xl">
            <MaskedLines delay={0.15} lines={[<>Domain fluency across the</>, <><span className="italic">energy &amp; commodity</span> spectrum.</>]} />
          </h1>
          <p className="mt-8 text-lg text-slate-300 max-w-2xl font-light leading-relaxed">
            From LNG cargoes to concentrate offtakes, our consultants speak the language of the desks they serve.
          </p>
        </motion.div>
      </section>

      <section className="container-x py-16">
        <div className="space-y-6">
          {INDUSTRIES.map((ind, i) => {
            const Icon = ind.icon;
            const reverse = i % 2 === 1;
            return (
              <motion.article
                key={ind.slug}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.7 }}
                className={`grid md:grid-cols-12 gap-8 items-center border border-white/5 bg-white/[0.02] overflow-hidden hover:border-[#D4AF37]/30 transition-all group`}
                data-testid={`industry-${ind.slug}`}
              >
                <div className={`md:col-span-5 aspect-[4/3] md:aspect-auto md:h-64 overflow-hidden ${reverse ? "md:order-2" : ""}`}>
                  <img src={ind.image} alt={ind.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className={`md:col-span-7 p-8 md:p-12 ${reverse ? "md:order-1" : ""}`}>
                  <div className="flex items-center gap-3 mb-4">
                    <Icon className="text-[#D4AF37]" size={22} strokeWidth={1.4} />
                    <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
                      Industry 0{i + 1}
                    </span>
                  </div>
                  <h2 className="font-display text-3xl md:text-4xl text-white font-medium tracking-tight">{ind.name}</h2>
                  <p className="mt-4 text-base text-slate-400 leading-relaxed max-w-xl">{ind.desc}</p>
                </div>
              </motion.article>
            );
          })}
        </div>
      </section>
    </div>
  );
}
